import React, { Component } from 'react';
import './Contact.css';

export default class Contact extends Component {

  render() {
    return(
      <div id="contact-container" className="contact-container">
        <div className="contact-section">
          <h1 className="contact-title">CONTACT</h1>
          <div className="contact-information">
            <h3>Email: <a href='mailto:andyliang144@gmail.com'>andyliang144@gmail.com</a></h3>
            <h3>GitHub: <a href="https://www.github.com/aliang6" target="_blank" rel="noopener noreferrer">https://www.github.com/aliang6</a></h3>
            <h3>LinkedIn: <a href="https://www.linkedin.com/in/andy-liang-677167127/" target="_blank" rel="noopener noreferrer">https://www.linkedin.com/in/andy-liang-677167127/</a></h3>
          </div>
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/Contact/Contact.js